// TODO: Start to move types into this file from the BFF and FE that are shared
export var JourneyMode;
(function (JourneyMode) {
    JourneyMode["ONBOARD"] = "ONBOARD";
    JourneyMode["ADD_ADDITIONAL_PROPERTY"] = "ADD_ADDITIONAL_PROPERTY";
})(JourneyMode || (JourneyMode = {}));
export var ExecutionType;
(function (ExecutionType) {
    ExecutionType["SYNC"] = "sync";
    ExecutionType["ASYNC"] = "async";
})(ExecutionType || (ExecutionType = {}));
export var ExecutionStatus;
(function (ExecutionStatus) {
    ExecutionStatus["RUNNING"] = "RUNNING";
    ExecutionStatus["SUCCEEDED"] = "SUCCEEDED";
    ExecutionStatus["FAILED"] = "FAILED";
    ExecutionStatus["TIMED_OUT"] = "TIMED_OUT";
    ExecutionStatus["ABORTED"] = "ABORTED";
})(ExecutionStatus || (ExecutionStatus = {}));
// Matches the names of the state machines in Terraform (./bff/infra/variables.state-machines) using the convention 'onboard-host' > 'ONBOARD_HOST'
export var StateMachineIdentifier;
(function (StateMachineIdentifier) {
    StateMachineIdentifier["ONBOARD_HOST"] = "ONBOARD_HOST";
    StateMachineIdentifier["ONBOARD_PROPERTY"] = "ONBOARD_PROPERTY";
    StateMachineIdentifier["ONBOARD_SMART_PRICING"] = "ONBOARD_SMART_PRICING";
})(StateMachineIdentifier || (StateMachineIdentifier = {}));
